











import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zakazka/store/edit';
import { Texty } from '@/modules/ciselnik/firemni/texty';
import { types } from '@/modules/servis/zakazka/store/types';
import { openSelectList, openEdit } from '@/main/router/routerPath';
import { TAB_NAMES, ZAKAZKA_STAV } from '@/modules/servis/zakazka/constants';
import { getStavZakazka } from '@/modules/servis/zakazka/utils';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { PageMode } from '@/main/utils/pageMode';

import ZakazkaPendingItems from './ZakazkaPendingItems.vue';

export default PageModeMixin.extend({
	name: 'FakturacniTexty',
	components: {
		ZakazkaPendingItems,
	},
	props: {
		storeUri: { type: String, default: null },
		disabled: { type: Boolean, default: false },
	},
	computed: {
		...genVuexComputeds(store),
		filter(): Record<string, any> {
			return {
				NvsprdnPrp: null,
				NvszavdPrp: null,
				OpravadokladPrp: null,
				PnvPrp: null,
				PovPrp: null,
				Poznamka: null,
				SkladpneuPrp: null,
				ZakazkaPrp: true,
				ZlPrp: null,
			};
		},
		isDisabledAddFaktText(): boolean {
			return [
				ZAKAZKA_STAV.UVOLNENA,
				ZAKAZKA_STAV.UZAVRENA,
				ZAKAZKA_STAV.VYRAZENA,
			].includes(getStavZakazka(this.edit)) || this.isViewMode;
		},
	},

	methods: {
		onAddFaktTextButtonClick(): void {
			this.selectedTab = TAB_NAMES.POZNAMKY;
			openSelectList(Texty.name, {
				afterRowSelection: this.selected,
				filter: this.filter,
			});
		},
		async selected({ row }: { row: Record<string, any> }) {
			const data = this.dbToBaseMapper(row);
			await this.$store.commit(`${this.storeUri}/${types.mutations.ZAKAZKA_ADD_FAKT_TEXT}`, { data });
		},
		dbToBaseMapper(data: Record<string, any>) {
			return {
				text: data.POLOZKA_TEXT,
			};
		},
	},
});
